import { TEST } from './entornos';

/** Entorno de TEST (`npm run start:test` / `build:test`). Fijo: no depende de `environment.ts`. */
export const environment = TEST;
